// extracted by mini-css-extract-plugin
export var button = "_dp-4";
export var hasDarkBackground = "_dp-7";
export var hasLightBackground = "_dp-6";
export var iconWrapper = "_dp-0";
export var large = "_dp-2";
export var medium = "_dp-1";
export var small = "_dp-5";
export var xsmall = "_dp-3";